module.exports = __webpack_public_path__ + "img/fb-logo.ff4156ee.svg";